import {
  ActivityIcon,
  AlertTriangleIcon,
  BadgeCheckIcon,
  ArchiveIcon,
  ArrowLeftRightIcon,
  BookOpenIcon,
  Building2Icon,
  CalendarCheckIcon,
  CalendarPlusIcon,
  CalendarRangeIcon,
  CarFrontIcon,
  ChartColumnIcon,
  CircleHelpIcon,
  ClipboardListIcon,
  CoinsIcon,
  ContactIcon,
  FileStackIcon,
  FilesIcon,
  FolderSyncIcon,
  GaugeIcon,
  HammerIcon,
  HouseIcon,
  IdCardIcon,
  InboxIcon,
  LandmarkIcon,
  LayersIcon,
  LayoutDashboardIcon,
  LayoutGridIcon,
  ListTodoIcon,
  MailIcon,
  MapIcon,
  MapPinIcon,
  MessageCircleIcon,
  MessageSquareIcon,
  NewspaperIcon,
  PackageIcon,
  PenLineIcon,
  PlugIcon,
  RouteIcon,
  RulerIcon,
  ScrollTextIcon,
  SettingsIcon,
  ShieldIcon,
  SparklesIcon,
  TagsIcon,
  TicketIcon,
  Trash2Icon,
  UserRoundIcon,
  UsersIcon,
  UsersRoundIcon,
  WalletIcon,
  WorkflowIcon,
  type LucideIcon,
} from 'lucide-react';

/**
 * One mark per destination, the same Lucide glyph the desktop navigation already uses.
 * A longer path wins, so a ticket detail keeps the ticket mark and does not inherit the module home.
 */
const PICTOGRAMS: Record<string, LucideIcon> = {
  '/start': LayoutDashboardIcon,
  '/helpdesk': LayoutDashboardIcon,
  '/helpdesk/tickets': TicketIcon,
  '/helpdesk/warteschlangen': LayersIcon,
  '/helpdesk/wissen': BookOpenIcon,
  '/helpdesk/changes': RouteIcon,
  '/helpdesk/freigaben': BadgeCheckIcon,
  '/helpdesk/sla': GaugeIcon,
  '/helpdesk/auswertung': ChartColumnIcon,
  '/helpdesk/assets': ArchiveIcon,
  '/helpdesk/automatisierung': WorkflowIcon,
  '/helpdesk/integrationen': PlugIcon,
  '/helpdesk/status': ActivityIcon,
  '/helpdesk/einstellungen/kategorien': TagsIcon,
  '/helpdesk/einstellungen/system': SettingsIcon,
  '/portal': HouseIcon,
  '/portal/tickets': TicketIcon,
  '/portal/wissen': BookOpenIcon,
  '/portal/faq': CircleHelpIcon,
  '/intranet': NewspaperIcon,
  '/intranet/wissensdatenbank': BookOpenIcon,
  '/intranet/bibliothek': BookOpenIcon,
  '/intranet/kollegen': UsersIcon,
  '/intranet/chat': MessageSquareIcon,
  '/intranet/ansprechpartner': ContactIcon,
  '/intranet/ki': SparklesIcon,
  '/intranet/redaktion': PenLineIcon,
  '/leave': LayoutDashboardIcon,
  '/leave/beantragen': CalendarPlusIcon,
  '/leave/antraege': ClipboardListIcon,
  '/leave/eingang': InboxIcon,
  '/leave/kalender': CalendarRangeIcon,
  '/leave/kolleginnen': UsersIcon,
  '/leave/vertretung': UserRoundIcon,
  '/leave/verwaltung': SettingsIcon,
  '/fleet': LayoutDashboardIcon,
  '/fleet/buchen': CalendarCheckIcon,
  '/fleet/kilometer': GaugeIcon,
  '/fleet/melden': AlertTriangleIcon,
  '/fleet/fahrten': RouteIcon,
  '/fleet/fahrzeuge': CarFrontIcon,
  '/fleet/aufgaben': ListTodoIcon,
  '/fleet/fahrer': IdCardIcon,
  '/fleet/betrieb': MapIcon,
  '/fleet/verwaltung': SettingsIcon,
  '/maintenance': LayoutDashboardIcon,
  '/maintenance/planung': CalendarRangeIcon,
  '/maintenance/archiv': ArchiveIcon,
  '/maintenance/papierkorb': Trash2Icon,
  '/maintenance/kunden': Building2Icon,
  '/maintenance/vorlagen': FileStackIcon,
  '/onboarding': LayoutDashboardIcon,
  '/onboarding/vorgaenge': FilesIcon,
  '/onboarding/vorlagen': FileStackIcon,
  '/tools': HammerIcon,
  '/stammdaten/partner': Building2Icon,
  '/stammdaten/artikel': PackageIcon,
  '/stammdaten/artikel/gruppen': LayoutGridIcon,
  '/stammdaten/zahlungen': WalletIcon,
  '/stammdaten/waehrungen': CoinsIcon,
  '/stammdaten/einheiten': RulerIcon,
  '/stammdaten/kostenstellen': LandmarkIcon,
  '/stammdaten/austausch': ArrowLeftRightIcon,
  '/verwaltung/benutzer': UsersIcon,
  '/verwaltung/abteilungen': Building2Icon,
  '/verwaltung/standorte': MapPinIcon,
  '/verwaltung/teams': UsersRoundIcon,
  '/verwaltung/berechtigungsgruppen': ShieldIcon,
  '/verwaltung/module': LayoutGridIcon,
  '/verwaltung/ki': SparklesIcon,
  '/verwaltung/e-mail': MailIcon,
  '/verwaltung/verzeichnis': FolderSyncIcon,
  '/verwaltung/audit': ScrollTextIcon,
  '/verwaltung/mandanten': LandmarkIcon,
  '/verwaltung/anrede': MessageCircleIcon,
};

export function menuPictogram(path: string): LucideIcon {
  const exact = PICTOGRAMS[path];
  if (exact) {
    return exact;
  }
  const prefix = Object.keys(PICTOGRAMS)
    .filter((key) => path.startsWith(`${key}/`))
    .sort((left, right) => right.length - left.length)[0];
  return (prefix ? PICTOGRAMS[prefix] : undefined) ?? LayoutGridIcon;
}
